module.exports = __webpack_public_path__ + "static/img/icon_guaduan_40px.3ab686f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_guaduan_40px.png
// module id = WH4l
// module chunks = 136